import { render, staticRenderFns } from "./AlDropdownDivider.vue?vue&type=template&id=23c70200&"
import script from "./AlDropdownDivider.vue?vue&type=script&lang=js&"
export * from "./AlDropdownDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports